import { Colors } from '@lightningjs/sdk'

// Lightning doesn't allow rgba color format, we need to apply the alpha value
export const getColor = (key: string, alpha?: number) => {
  return Colors(key)
    .alpha(alpha || 1)
    .get()
}

// Color scheme
export const appTheme = {
  active: '#1669b2',
  backgroundDark: '#090D11',
  backgroundLight: '#0E141B',
  focus: '#1e88e5',
  primaryText: '#ffffff',
  secondaryText: '#bdbdbd',
  unfocus: '#4b4b4b',
  // App colors
  black: '#000000',
  white: '#FFFFFF',
  grey800: '#232327',
  grey700: '#3D3D41',
  grey50: '#F2F2F2',
  grey960: '#0C0C0C',
  grey920: '#18181A',
  grey200: '#BEBEC0',
  grey300: '#A5A5A7',
  grey500: '#838386',
  primary400: '#FF5445',
  primary500: '#FF140F',
  grey400: '#909093',
  primary600: '#D3120D',
  grey600: '#6A6A6E',
  cancel: '#FF7A00',
  grey100: '#D8D8D9',
}

// Color keys
export const backgroundDark = 'backgroundDark'
export const backgroundLight = 'backgroundLight'
export const focus = 'focus'
export const unfocus = 'unfocus'
export const active = 'active'
export const secondaryText = 'secondaryText'
export const primaryText = 'primaryText'
// App colors keys
export const black = 'black'
export const white = 'white'
export const grey800 = 'grey800'
export const grey700 = 'grey700'
export const grey50 = 'grey50'
export const grey960 = 'grey960'
export const grey920 = 'grey920'
export const grey200 = 'grey200'
export const grey300 = 'grey300'
export const grey500 = 'grey500'
export const primary400 = 'primary400'
export const primary500 = 'primary500'
export const grey400 = 'grey400'
export const primary600 = 'primary600'
export const grey600 = 'grey600'
export const cancel = 'cancel'
export const grey100 = 'grey100'

// Special utility colors
export const transparent = 0x00000000
